<template>
  <Block
    type="onestoreSubscribePageContainer"
    id="onestoreSubscribe"
    :class="$platformClass"
  >
    <Block tagName="div" type="subscribeManageContent">
      <Block tagName="div" type="subscribeManage">
        <Mark type="subscribeTitle">{{
          languages.onestore_subscribe_manage
        }}</Mark>
        <template v-if="isLogin && isCharInfoFulfill && hasValidItem">
          <one-sub-list-item
            v-for="(item, index) in validList"
            :key="item.id"
            v-bind="item"
            :index="index"
          ></one-sub-list-item>
        </template>
        <Mark v-else type="onestoreSubscribeTip">{{ manageTip }}</Mark>
      </Block>
      <Block tagName="div" type="subscribeManage" v-if="hasExpireItem">
        <Mark type="subscribeTitle">{{
          languages.onestore_subscribe_has_expire
        }}</Mark>
        <Mark type="expireTips">{{
          languages.onestore_subscribe_expired_tip
        }}</Mark>
        <one-sub-list-item
          v-for="item in expiredList"
          :key="item.id"
          v-bind="item"
        ></one-sub-list-item>
      </Block>
    </Block>
    <one-sub-privacy :privacyLink="privacyLink"></one-sub-privacy>
  </Block>
</template>
<script>
import OneSubListItem from '@components/passport/OneSubListItem';
import OneSubPrivacy from '@components/passport/OneSubPrivacy';
import globalConfig from '@utiles/globalConfig';
import { mapState } from 'vuex';
import {
  GET_SUBSCRIBE,
  CHECK_LOGIN_ACTION,
} from '@store/passport/onestoreSubscribe';
export default {
  name: 'onestoreSubscribeList',
  data() {
    return {
      isLogin: false,
      charInfo: {
        serverId:
          globalConfig.getHrefParam('serverId') ||
          globalConfig.getHrefParam('serverID') ||
          globalConfig.getHrefParam('server_id') ||
          '',
        roleId:
          globalConfig.getHrefParam('roleId') ||
          globalConfig.getHrefParam('roleID') ||
          globalConfig.getHrefParam('role_id') ||
          '',
        gameId:
          globalConfig.getHrefParam('gameId') ||
          globalConfig.getHrefParam('gameID') ||
          globalConfig.getHrefParam('game_id') ||
          '',
        packageName: globalConfig.getHrefParam('packageName') || '',
      },
      isCharInfoFulfill: false, //角色信息是否完备
    };
  },
  computed: {
    ...mapState({
      languages: state => state.onestoreSubscribe.languages,
      validList: state => state.onestoreSubscribe.validList,
      expiredList: state => state.onestoreSubscribe.expiredList,
      privacyLink: state => state.onestoreSubscribe.privacyLink,
    }),
    hasValidItem() {
      return this.validList.length > 0;
    },
    hasExpireItem() {
      return this.expiredList.length > 0;
    },
    manageTip() {
      if (!this.isLogin || !this.isCharInfoFulfill) {
        return this.languages.onestore_subscribe_get_role_fail;
      }
      if (!this.hasValidItem) {
        return this.languages.onestore_subscribe_do_not_subscribe;
      }
    },
  },
  async created() {
    await this.checkLogin();
    this.checkCharInfoFulfill();
    this.isLogin && this.isCharInfoFulfill && this.initData();
  },
  methods: {
    async checkLogin() {
      let isLogin = await this.$store.dispatch(CHECK_LOGIN_ACTION);
      this.isLogin = isLogin;
    },
    checkCharInfoFulfill() {
      this.isCharInfoFulfill =
        this.charInfo.gameId &&
        this.charInfo.serverId &&
        this.charInfo.roleId &&
        this.charInfo.packageName;
    },
    initData() {
      this.$store.dispatch(GET_SUBSCRIBE, this.charInfo);
    },
  },
  components: {
    OneSubListItem,
    OneSubPrivacy,
  },
};
</script>
